// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__lUTVf","subTitleBold":"BoxSubTitle_subTitleBold__ioxSo"};